/**
 * Products in the Contact-hero showcase, in visual-hierarchy order. All four are real Shingare product photographs as transparent
 * cutouts at native resolution (provenance: public/images/home/hero/SOURCES.md; nothing is generated or redrawn).
 *
 * Intended visual weight: tube cleaner ≈ 40–45 %, pipe beveling ≈ 20–25 %, tube expansion ≈ 15–20 %, torque ≈ 10–15 %.
 * Weight follows each cutout's on-stage area, so the widths below are chosen from the products' own aspect ratios.
 *
 * Layout values are % of the stage (`l` left, `t` top, `w` width) per breakpoint:
 *   base = phones (2 products), md = tablets (3), lg = desktop (all 4). A breakpoint that is left out hides the product there.
 * `depth` scales the (tiny) pointer parallax; `delay` is the entrance stagger in seconds; `dy` the entrance rise in px.
 * `label` = a small technical caption (≥1280 px only) placed at `lx`/`ly` (% of the stage).
 */
export const CONTACT_HERO_PRODUCTS = [
  {
    id: "tube-cleaner",
    src: "/images/home/hero/tube-cleaner.webp",
    w: 603, h: 529,
    layout: { base: { l: 0, t: 22, w: 66 }, md: { l: 0, t: 34, w: 72 }, lg: { l: 26, t: 42, w: 52 } },
    z: 30, depth: 0.5, delay: 0, dy: 15,
    label: { text: "Tube cleaning", lx: 4, ly: 86, align: "left" },
  },
  {
    id: "pipe-beveling",
    src: "/images/home/hero/pipe-beveling.webp",
    w: 495, h: 552,
    layout: { base: { l: 56, t: 0, w: 40 }, md: { l: 54, t: 2, w: 44 }, lg: { l: 4, t: 9, w: 32 } },
    z: 20, depth: 0.9, delay: 0.1, dy: 20,
    label: { text: "Pipe preparation", lx: 4, ly: 55, align: "left" },
  },
  {
    id: "tube-expansion",
    src: "/images/home/hero/tube-expansion.webp",
    w: 579, h: 273,
    layout: { md: { l: 30, t: 76, w: 66 }, lg: { l: 54, t: 2, w: 44 } },
    z: 25, depth: 1, delay: 0.18, dy: 20,
    label: { text: "Tube expansion", lx: 98, ly: 31, align: "right" },
  },
  {
    id: "torque-wrench",
    src: "/images/home/hero/torque-wrench.webp",
    w: 656, h: 272,
    layout: { lg: { l: 62, t: 76, w: 36 } },
    z: 35, depth: 0.8, delay: 0.26, dy: 20,
    label: { text: "Industrial bolting", lx: 98, ly: 98, align: "right" },
  },
];

export const CONTACT_HERO_ARIA = "Shingare product range: tube cleaner, pipe beveling machine, tube expansion tool and hydraulic torque wrench";
